import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject, input, output } from '@angular/core';
import { FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';

import { AppSettings } from '@app/data/models';
import { MatCard, MatCardContent, MatCardTitle } from '@angular/material/card';
import { MatFormField, MatError, MatLabel } from '@angular/material/form-field';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { MatOptgroup, MatOption } from '@angular/material/core';

import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatInput } from '@angular/material/input';

@Component({
    selector: 'admin-admin-actions',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: `./admin-actions.component.html`,
    styleUrl: `./admin-actions.component.scss`,
    imports: [
        ReactiveFormsModule,
        MatCard,
        MatCardContent,
        MatCardTitle,
        MatFormField,
        MatSelect,
        MatOptgroup,
        MatOption,
        MatError,
        MatButton,
        MatProgressSpinner,
        MatCheckbox,
        MatInput,
        MatLabel,
    ],
})
export class AdminActionsComponent {
    fb = inject(FormBuilder);

    form = this.fb.group({
        action: ['', [Validators.required]],
        sendToQueue: [false],
        payload: [''],
    });

    readonly isPending = input<boolean | null>(null);
    readonly settings = input<AppSettings | null>(null);

    readonly executeAction = output<{ action: string; sendToQueue: boolean; payload: string }>();

    onExecuteAction() {
        if (this.form.invalid) {
            return;
        }

        this.executeAction.emit(this.form.value as any);
    }

    onActionChange(event: MatSelectChange) {
        switch (event.value) {
            case 'calc-shareable-links':
                this.form.patchValue({
                    payload: JSON.stringify(['rowkey'], null, 4),
                });

                break;
            case 'send-email-from-templateId':
                {
                    const model = {
                        to: '',
                        subject: 'Test Email',
                        templateId: 'templates/test-template.liquid',
                        model: { userFirstName: 'John', userLastName: 'Doe' },
                        sendReport: true,
                        clearCache: false,
                    };

                    this.form.patchValue({
                        payload: JSON.stringify(model, null, 4),
                    });
                }
                break;
        }
    }
}
